export const PARIS_CENTER = {
  latitude: 48.856614,
  longitude: 2.3522219,
  formatted: 'Paris, Île-de-France, France',
  zip: '75004',
  city: 'Paris',
  regionName: 'Île-de-France',
  country: 'France',
  ip: null as string | null,
}
